<template>
  <div class="BookingHelpCenter">
    <ai-typo
      class="BookingHelpCenter-title"
      as="h2"
      variant="paragraph-01-bold"
      color="neutral-800">
      {{ $t('booking.helpCenter.title') }}
    </ai-typo>
    <div class="BookingHelpCenter-block">
      <ai-link
        class="BookingHelpCenter-link"
        :url="$t('booking.helpCenter.link')"
        :text="$t('booking.helpCenter.linkLabel')"
        icon-right="button-arrow-right"
        typo-variant="button-bold"
        color="gold-900"
        target="_blank" />
      <ai-typo as="p" variant="paragraph-04-regular" color="neutral-800">
        {{ $t('booking.helpCenter.text') }}
      </ai-typo>
    </div>
    <ai-separator :margin="2" />
  </div>
</template>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/mq';

.BookingHelpCenter {
  display: flex;
  flex-direction: column;
}

.BookingHelpCenter-title {
  margin-bottom: constants.$margin-01;

  @media (mq.$from-medium) {
    margin-bottom: constants.$margin-02;
  }
}

.BookingHelpCenter-link {
  text-transform: uppercase;
  color: colors.$gold-900;
  margin-bottom: constants.$margin-00;
}

.BookingHelpCenter-block {
  display: flex;
  flex-direction: column;
}
</style>
